import zh_CN from 'antd/lib/locale/zh_CN'
import en_US from 'antd/lib/locale/en_US'
import { Locale } from 'antd/lib/locale-provider'

import i18n from './i18n'

export type Lang = 'zh_CN' | 'en_US'

let language = window.localStorage.getItem('language')

if (!language) {
  language = 'zh_CN'
  window.localStorage.setItem('language', 'zh_CN')
}

export const locale: { [lang: string]: Locale } = {
  'zh_CN': zh_CN,
  'en_US': en_US,
}

export default i18n[(language as Lang)]